import React from 'react';

import { Logo } from '@/shared/components/ui/logo/logo';
import { useAppTheme } from '@/shared/features/theme-switcher/context/theme-context';
import { LogoVariantEnum, ThemeEnum } from '@/shared/types/common.types';
import { getReseller } from '@/shared/utils/reseller/reseller';

// Eagerly import all reseller logos
const resellerLogos = import.meta.glob<{ ResellerLogo: React.FC }>(
  '../../../../../reseller/*/logo/reseller-logo.tsx',
  { eager: true },
);

// Get the reseller logo based on the reseller name
const getResellerLogo = (reseller?: string): React.FC | null => {
  if (!reseller) {
    console.error('VITE_APP_SUPER_TENANT is not defined');
    return null;
  }

  // Find the logo that matches the reseller name
  const logoEntry = Object.entries(resellerLogos).find(([path]) =>
    path.includes(`/${reseller}/logo/reseller-logo.tsx`),
  );

  if (!logoEntry) {
    console.error(`Reseller logo not found for: ${reseller}`);
    return null;
  }

  return logoEntry[1].ResellerLogo;
};

export const ConditionalLogo: React.FC = () => {
  const { selectedTheme } = useAppTheme();
  const reseller = getReseller();

  if (reseller !== 'sda') {
    const ResellerLogo = getResellerLogo(reseller);

    if (!ResellerLogo) {
      return null;
    }

    return <ResellerLogo />;
  }

  return (
    <>
      <Logo
        variant={LogoVariantEnum.ICON}
        isDarkMode={selectedTheme !== ThemeEnum.LIGHT}
      />
      <Logo
        variant={LogoVariantEnum.TEXT}
        isDarkMode={selectedTheme !== ThemeEnum.LIGHT}
      />
    </>
  );
};
